import React from "react";
import { SET_TOKEN } from "./../../constants/auth/auth";

const JsonConverter = (str) => {
  try {
    return JSON.parse(str);
  } catch {
    return {};
  }
};
const getTokenDetails = (base64String) => {
  try {
    let storedValue = window.atob(base64String);
    return storedValue;
  } catch (error) {
    return "";
  }
};
const storedDetails = JsonConverter(
  getTokenDetails(localStorage.getItem("tk"))
);

const role = getTokenDetails(storedDetails.ur);
const accessToken = getTokenDetails(storedDetails.atk);
const refreshToken = getTokenDetails(storedDetails.rtk);
const userManagement = getTokenDetails(storedDetails.uma);

const LOGIN_DEATILS = {
  role,
  accessToken,
  refreshToken,
  userManagement,
};

export const loginInfo = (state = LOGIN_DEATILS, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        role: action.payload.role,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        userManagement: action.payload.userManagement,
      };
    default:
      return state;
  }
};